import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(_param) {
    var color = _param.color, height = _param.height, props = _object_without_properties(_param, [
        "color",
        "height"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 375 400",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M375 344.831V0H-3.05176e-05V334.939C2.88681 355.427 36.0662 397.092 145.689 399.858C255.312 402.624 344.239 364.326 375 344.831Z",
            fill: color
        })
    }));
};
export default Icon;
